import React from 'react'

import { DataGrid } from '@material-ui/data-grid'

import api from 'services/api'

function TableGrid ({ select, setSelection, descriptionRequests, setDescriptionRequests, rows }) {
  const columns = [
    { field: 'id', headerName: 'Nº', width: 70 },
    { field: 'status', headerName: 'Status', width: 170 },
    { field: 'tabe_number', headerName: 'Nº Mesa', width: 170 }
  ]
  const onSelectionChanged = (selections) => {
    for (var i = 0; i < rows.length; i++) {
        if (rows[i].id === selections[0]) {
            
           if (select !== selections) {
              setSelection(rows[i])
              getDescription(selections[0])
            }

        }
    }

  }   

  const getDescription = async (id) => {

    try {

      const requestsProductsDescription = await api.get(`/requests/${id}`)
      setDescriptionRequests(requestsProductsDescription.data.object)

    } catch (err) {
      console.log(err)
    }
  }

  return (
    <div style={{ height: 400, width: '100%' }}>
      {rows && <DataGrid
        rows={rows}
        columns={columns}
        NoRowsOverlay
        pageSize={5}
        onSelectionModelChange={onSelectionChanged}
      />}
    </div>
  )
}

export default TableGrid
